import React, { useState } from 'react';
import convertToOvariant from '../../utils/convertToOvariant';
import api from '../../services/api';
import useTranslate from '../../customHooks/useTranslate';
import { savableEntities } from '../../utils/commonVariables/entityKeys';
import { publicEndpoints } from '../../utils/commonVariables/endpoints';
import { Card, CardActions, CardContent } from '@mui/material';
import conejoLogin from '../../images/conejito.svg';
import TextInput from '../../muiComponents/TextInput/TextInput';
import Button from '../../muiComponents/Button';
import { validateForm } from '../../utils/validateForms';

export default function FormForgotPassword() {
    const [email, setEmail] = useState('');
    const [validated, setValidated] = useState(false);
    const [errorDDBB, setErrorDDBB] = useState(false);
    const [validationErrors, setValidationErrors] = useState([]);
    const [sendedEmail, setSendedEmail] = useState(false);

    const handleChangeInput = event => {
        const { value } = event.currentTarget;
        setEmail(value);
    };

    const handleBlur = () => {
        if (validated) {
            handleValidate();
        }
    };

    const fieldsToValidate = {
        EmailAddress: {
            value: email,
            validators: ['requiredString', 'email'],
        },
    };

    const handleValidate = () => {
        const formErrors = validateForm(fieldsToValidate);
        setValidationErrors(formErrors);
        return !formErrors.length;
    };

    const handleSubmit = async () => {
        try {
            setValidated(true);
            const isValid = handleValidate();
            if (!isValid) {
                return;
            }
            setValidationErrors([]);
            const emailToSend = { Email: email };
            const objectToSend = convertToOvariant(
                savableEntities.SystemUser,
                emailToSend
            );

            const endpoint = publicEndpoints.forgotPassword;
            const res = await api.post(endpoint, objectToSend);
            if (res.status === 200) {
                setSendedEmail(true);
            } else {
                setErrorDDBB(true);
            }
        } catch (error) {
            console.log(error);
            setErrorDDBB(true);
        }
    };

    const sendEmailText = useTranslate('sended_email');
    const somethingWrongText = useTranslate('something_went_wrong');

    return (
        <main className='main__login'>
            <div className='flex-column flex-center flex-align-center'>
                <Card
                    className='flex-column gap-10'
                    sx={{
                        width: 380,
                        padding: '40px 50px',
                    }}
                >
                    <CardContent className='padding0 gap-20 flex-column flex-center flex-align-center'>
                        <img
                            alt={'Fast pay hotel logo'}
                            src={conejoLogin}
                            height={120}
                        />
                        <p className='text-align-center'>{`${useTranslate(
                            'forgot_password_text'
                        )}`}</p>
                        <TextInput
                            type='email'
                            required
                            labelText={useTranslate('email')}
                            handleChange={e => handleChangeInput(e)}
                            onBlur={handleBlur}
                            name='email'
                            errorMessage={
                                validated &&
                                validationErrors.length &&
                                validationErrors?.[0]?.errorMessage
                            }
                        />
                    </CardContent>
                    <CardActions className='flex-column flex-center flex-align-center gap-10'>
                        <Button
                            variant='contained'
                            className='button-submit'
                            onClick={handleSubmit}
                        >{`${useTranslate('send')}`}</Button>

                        {sendedEmail && (
                            <div className='text-align-center'>
                                <p>{`${sendEmailText}`}</p>
                            </div>
                        )}
                        {errorDDBB && (
                            <div className='text-align-center'>
                                <p className='text-error-color'>{`${somethingWrongText}`}</p>
                            </div>
                        )}
                    </CardActions>
                </Card>
            </div>
        </main>
    );
}
